var map = {
	"./battery-active.png": "1129",
	"./battery-cabinet.png": "3dd7",
	"./battery-offline.png": "beff",
	"./battery-offline2.png": "cfb4",
	"./battery-online.png": "11c7",
	"./battery-overdue.png": "8ec5",
	"./battery-user.png": "e1ef",
	"./bike-offline.png": "d332",
	"./bike-online.png": "e438",
	"./box-offline.png": "c211",
	"./box-online.png": "6f87",
	"./control1.png": "53bd",
	"./control10.png": "9990",
	"./control11.png": "285c",
	"./control12.png": "0338",
	"./control2.png": "2d69",
	"./control3.png": "8885",
	"./control4.png": "a282",
	"./control5.png": "bae9",
	"./control6.png": "a100",
	"./control7.png": "2ec6",
	"./control8.png": "3cf3",
	"./control9.png": "0e98",
	"./cpbox-offline.png": "019c",
	"./cpbox-online.png": "7cd6",
	"./ddc.png": "8b75",
	"./home-avatar.png": "7f7e",
	"./home-card-bg.png": "b050",
	"./login_bg_new2.png": "9540",
	"./pile-active.png": "920b",
	"./pile-offline.png": "5afb",
	"./pile-online.png": "6155",
	"./stat/b1.png": "19a0",
	"./stat/b2.png": "56d5",
	"./stat/b3.png": "c142",
	"./stat/bg.png": "ba53",
	"./stat/empty.png": "9e31",
	"./stat/l1.png": "a3d7",
	"./stat/l2.png": "2841",
	"./stat/l3.png": "feaf",
	"./stat/l4.png": "d1d5",
	"./stat/l5.png": "bbaa",
	"./stat/l6.png": "be74",
	"./stat/r1.png": "4563",
	"./stat/r2.png": "3f48",
	"./stat/r3.png": "155a",
	"./stat/r4.png": "757b",
	"./stat/r5.png": "4aea",
	"./stat/r6.png": "2c34",
	"./stat/title.png": "bd29",
	"./statistics_icon1.png": "a497",
	"./statistics_icon2.png": "b5b3",
	"./statistics_icon3.png": "6b07",
	"./statistics_icon4.png": "9711"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";